import settings from '@/settings'

export function useSettings() {
  return settings
}
